export default __webpack_public_path__ + "static/media/user-search-fill.f4fe2487.svg";